export default __webpack_public_path__ + "c0e14da4.png";